import { render, staticRenderFns } from "./DetailGatewayForm.vue?vue&type=template&id=3734c128"
import script from "./DetailGatewayForm.vue?vue&type=script&lang=js"
export * from "./DetailGatewayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports